module.exports = __webpack_public_path__ + "static/media/Through the Fire - Instrumental Version.ce68bd31.jpg";